import { gql } from '@apollo/client'

// Dedicated lookup for the redesigned private lesson confirmation. The shared
// `ProductByPaymentIntentId` (`../../query.js`) does not select the coach's
// cancellation fields the callout needs, so the redesign passes this document
// to `useGetProductByPaymentIntentId` instead (the same way Virtual Coaching
// does) and the shared query stays as it was.
export const PRIVATE_LESSON_PRODUCT_BY_PAYMENT_INTENT_ID = gql`
  query PrivateLessonProductByPaymentIntentId($paymentIntentId: String!) {
    productByPaymentIntentId(paymentIntentId: $paymentIntentId) {
      ... on Enrollment {
        lesson {
          id
          title
          startDateTime
          endDateTime
          coachFacility {
            id
            name
            city
            state
            timezone
          }
          coach {
            id
            bookingUrl
            name
            canStudentCancel
            cancellationPolicy
            coachProfile {
              profilePhoto
              title
              memberType
              certificationLevel
            }
          }
        }
        transactions {
          amountInCents
          registrationPayment {
            cardBrand
            last4
          }
        }
        student {
          firstName
          lastName
          contact {
            email
          }
        }
      }
    }
  }
`
